const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/dashboards/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/dashboards/')({
  beforeLoad: ({
    context: {
      flags
    },
    params: {
      org
    }
  }) => {
    if (!flags.visualizationsOrgLevelDashboardsEnabled) {
      throw redirect({
        to: '/org/$org',
        params: {
          org
        },
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});